async function request(url: string, options: RequestInit = {}): Promise<any> {
  const token = localStorage.getItem('auth_token');
  const headers: Record<string, string> = {
    'Content-Type': 'application/json',
    ...(options.headers as Record<string, string> || {}),
  };
  if (token) {
    headers['Authorization'] = `Bearer ${token}`;
  }

  const finalUrl = url;

  const res = await fetch(finalUrl, {
    ...options,
    headers,
  });

  if (res.status === 401) {
    localStorage.removeItem('auth_token');
    window.location.href = '/login';
    throw new Error('Unauthorized');
  }

  const data = await res.json();
  return data;
}

export const get = <T = any>(url: string, params?: Record<string, any>): Promise<T> => {
  let finalUrl = url;
  if (params) {
    const searchParams = new URLSearchParams();
    Object.entries(params).forEach(([key, value]) => {
      if (value !== undefined && value !== null) {
        searchParams.append(key, String(value));
      }
    });
    const qs = searchParams.toString();
    if (qs) finalUrl += (finalUrl.includes('?') ? '&' : '?') + qs;
  }
  return request(finalUrl);
};
export const post = <T = any>(url: string, data?: any): Promise<T> => request(url, { method: 'POST', body: JSON.stringify(data) });
export const put = (url: string, data?: any) => request(url, { method: 'PUT', body: JSON.stringify(data) });
export const del = (url: string) => request(url, { method: 'DELETE' });
